import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 4px solid ${({ borderColor }) => borderColor || '#f3f3f3'};
  border-top: 4px solid ${({ topColor }) => topColor || '#3498db'};
  border-radius: 50%;
  width: ${({ size }) => size || '40px'};
  height: ${({ size }) => size || '40px'};
  animation: ${spin} 1s linear infinite;
  margin: 0 auto;
`;

export const LoadingScreen = ({
  value = "Loading...",
  size = "50px",
  borderColor = "#e0e0e0",
  topColor = "#6a11cb",
}) => {
  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <Spinner size={size} borderColor={borderColor} topColor={topColor} />
      <p>{value}</p>
    </div>
  );
};